import NpvrStore from './store-npvr';

export class RootStore {
  npvrStore: NpvrStore;

  constructor() {
    this.npvrStore = new NpvrStore();
  }
}

export const rootStore = new RootStore();
